/* eslint-disable */

import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Space,
  Typography,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Tag,
} from 'antd';
import {
  AppstoreOutlined,
  PlusOutlined,
  ReloadOutlined,
  FileExcelOutlined,
  EditOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import './ProductCategory.css';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const { Title, Text } = Typography;

function ProductCategory(props) {
  const [form] = Form.useForm();
  const [productcategory_list, setProductCategory_List] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [productmode, setProductmode] = useState('');
  const [currentCategory, setCurrentCategory] = useState(null);

  useEffect(() => {
    getProductList();
  }, []);

  const sortedCategories = useMemo(() => {
    return [...productcategory_list].sort(
      (a, b) => Number(a.productcategory_sortno || 0) - Number(b.productcategory_sortno || 0),
    );
  }, [productcategory_list]);

  async function getProductList() {
    setLoading(true);

    const formData = new FormData();
    formData.append('filter', 'approved');

    axios
      .post(props.app_hostname + '/api/product/category/getlist', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        if (response.data.status !== 'OK') {
          setLoading(false);
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
          return;
        }

        setProductCategory_List(response.data.products || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  function handleAdd() {
    setProductmode('add');
    setCurrentCategory(null);
    form.resetFields();
    form.setFieldsValue({
      productcategory_id: '-',
      productcategory_name: '',
      productcategory_inter: '',
      productcategory_sortno: '',
    });

    setIsModalOpen(true);
  }

  function handleEdit(record) {
    setProductmode('edit');
    setCurrentCategory(record);
    form.setFieldsValue({
      productcategory_id: record.productcategory_id,
      productcategory_name: record.productcategory_name,
      productcategory_inter: record.productcategory_inter || '',
      productcategory_sortno: record.productcategory_sortno,
    });

    setIsModalOpen(true);
  }

  async function handleSubmit(values) {
    setModalLoading(true);

    const formData = new FormData();
    formData.append('productcategory_id', values.productcategory_id);
    formData.append('productcategory_name', values.productcategory_name);
    formData.append('productcategory_inter', values.productcategory_inter);
    formData.append('productcategory_sortno', values.productcategory_sortno);
    formData.append('username', props.permitdata.username);

    axios
      .post(props.app_hostname + '/api/product/category/' + productmode, formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setModalLoading(false);
        if (response.data.status === 'OK') {
          setProductCategory_List(response.data.products);
          setIsModalOpen(false);
          message.success('บันทึกหมวดหมู่สินค้าสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setModalLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function handleDelete(record) {
    setLoading(true);

    var postdata = {
      productcategory_id: record.productcategory_id,
    };
    axios
      .post(props.app_hostname + '/api/product/category/delete', postdata, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          setProductCategory_List(response.data.products);
          message.success('ลบหมวดหมู่สินค้าสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  function convertJSONToCSV(jsonData, columnHeaders) {
    if (jsonData.length === 0) {
      return '';
    }

    const headers = columnHeaders.join(',') + '\n';
    const rows = jsonData
      .map((row) => {
        return columnHeaders.map((field) => row[field] || '').join(',');
      })
      .join('\n');

    return headers + rows;
  }

  function downloadCSV() {
    var headers = [
      'productcategory_id',
      'productcategory_name',
      'productcategory_sortno',
      'createtime',
      'edittime',
      'useredit',
    ];
    const csvData = convertJSONToCSV(productcategory_list, headers);

    if (csvData === '') {
      message.warning('ไม่มีข้อมูลสำหรับส่งออก');
    } else {
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'meya_category.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  const columns = [
    {
      title: '#',
      key: 'index',
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: 'รหัสหมวดหมู่',
      dataIndex: 'productcategory_id',
      key: 'productcategory_id',
      width: 120,
      sorter: (a, b) => a.productcategory_id?.localeCompare(b.productcategory_id),
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'ลำดับการแสดง',
      dataIndex: 'productcategory_sortno',
      key: 'productcategory_sortno',
      width: 120,
      align: 'center',
      sorter: (a, b) => Number(a.productcategory_sortno) - Number(b.productcategory_sortno),
    },
    {
      title: 'ชื่อหมวดหมู่',
      dataIndex: 'productcategory_name',
      key: 'productcategory_name',
      sorter: (a, b) => a.productcategory_name?.localeCompare(b.productcategory_name),
    },
    {
      title: 'จัดการ',
      key: 'action',

      width: 180,
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            type='primary'
            icon={<EditOutlined />}
            size='small'
            onClick={() => handleEdit(record)}
          >
            แก้ไข
          </Button>
          <Popconfirm
            title='ยืนยันการลบ'
            description='คุณแน่ใจหรือไม่ที่จะลบหมวดหมู่นี้?'
            onConfirm={() => handleDelete(record)}
            okText='Yes'
            cancelText='No'
          >
            <Button type='primary' danger icon={<DeleteOutlined />} size='small'>
              ลบ
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const renderMobileList = () => (
    <div className='category-list-container'>
      {sortedCategories.map((record, index) => (
        <div
          key={record.productcategory_id}
          className='category-card animate-fade-up'
          style={{ animationDelay: `${index * 0.05}s` }}
        >
          <div className='category-info'>
            <div className='category-id-badge'>{record.productcategory_id}</div>
            <div className='category-name'>{record.productcategory_name}</div>
          </div>
          <div className='category-actions'>
            <Button
              ghost
              type='primary'
              className='btn-edit-outline'
              size='small'
              onClick={() => handleEdit(record)}
            >
              แก้ไข
            </Button>
            <Popconfirm
              title='ยืนยันการลบ'
              description='คุณแน่ใจหรือไม่ที่จะลบหมวดหมู่นี้?'
              onConfirm={() => handleDelete(record)}
              okText='Yes'
              cancelText='No'
            >
              <Button ghost type='primary' danger className='btn-delete-outline' size='small'>
                ลบ
              </Button>
            </Popconfirm>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div>
              <Title level={3} style={{ margin: 0 }}>
                <AppstoreOutlined style={{ color: '#fa8c16', marginRight: '8px' }} />
                หมวดหมู่สินค้า
              </Title>
              <Text type='secondary'>จัดการหมวดหมู่สินค้าทั้งหมด</Text>
            </div>
            <Space>
              <Button icon={<PlusOutlined />} type='primary' onClick={handleAdd}>
                เพิ่มใหม่
              </Button>
              <Button icon={<ReloadOutlined />} onClick={getProductList} loading={loading}>
                รีเฟรช
              </Button>
              <Button icon={<FileExcelOutlined />} onClick={downloadCSV}>
                ส่งออก CSV
              </Button>
            </Space>
          </div>

          <div>
            <Title level={5} style={{ marginBottom: '16px' }}>
              รายการหมวดหมู่สินค้า <span>({productcategory_list.length} หมวดหมู่)</span>
            </Title>
            {props.isMobile ? (
              renderMobileList()
            ) : (
              <Table
                columns={columns}
                dataSource={sortedCategories}
                rowKey='productcategory_id'
                loading={loading}
                pagination={{ pageSize: 10, showTotal: (total) => `ทั้งหมด ${total} หมวดหมู่` }}
                scroll={{ x: 'max-content' }}
              />
            )}
          </div>
        </Space>
      </div>

      <Modal
        title={
          <Space>
            <AppstoreOutlined />
            {productmode === 'add' ? 'เพิ่มหมวดหมู่สินค้า' : 'แก้ไขหมวดหมู่สินค้า'}
          </Space>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={600}
        centered
      >
        <Form
          form={form}
          layout='vertical'
          onFinish={handleSubmit}
          className='category-modal-form'
          style={{ marginTop: '24px' }}
        >
          <Form.Item name='productcategory_id' label='รหัสหมวดหมู่'>
            <Input disabled />
          </Form.Item>
          <div className='drug-license-field'>
            <div className='drug-license-header'>
              <span className='drug-license-label'>
                <span className='drug-license-required'>*</span> ทะเบียนยา
              </span>
              <Link
                className='drug-license-manage-link'
                to={
                  currentCategory?.productcategory_id
                    ? `/product/category/license?id=${encodeURIComponent(currentCategory.productcategory_id)}`
                    : '/product/category/license'
                }
              >
                จัดการสิทธิ์ทะเบียนยา
              </Link>
            </div>
            <div className='drug-license-badges'>
              {(currentCategory?.drug_licenses || []).map((label) => (
                <Tag key={label} className='drug-license-badge'>
                  {label}
                </Tag>
              ))}
            </div>
          </div>
          <Form.Item
            name='productcategory_name'
            label='ชื่อหมวดหมู่ (ไทย)'
            rules={[
              { required: true, message: 'กรุณากรอกชื่อหมวดหมู่ (ไทย)' },
              { min: 2, message: 'ชื่อหมวดหมู่ต้องมีอย่างน้อย 2 ตัวอักษร' },
            ]}
          >
            <Input placeholder='กรอกชื่อหมวดหมู่สินค้า' />
          </Form.Item>
          <Form.Item
            name='productcategory_inter'
            label='ชื่อหมวดหมู่ (อังกฤษ)'
            rules={[
              { required: true, message: 'กรุณากรอกชื่อหมวดหมู่ (อังกฤษ)' },
              { min: 2, message: 'ชื่อหมวดหมู่ต้องมีอย่างน้อย 2 ตัวอักษร' },
            ]}
          >
            <Input placeholder='Enter category name (EN)' />
          </Form.Item>

          <Form.Item
            name='productcategory_sortno'
            label='ลำดับการแสดง'
            rules={[{ required: true, message: 'กรุณากรอกลำดับการแสดงผล' }]}
          >
            <InputNumber
              min={1}
              max={1000}
              style={{ width: '100%' }}
              placeholder='กรอกลำดับการแสดงผล (1-1000)'
            />
          </Form.Item>
          <div
            style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '24px' }}
          >
            <Button onClick={() => setIsModalOpen(false)}>ยกเลิก</Button>
            <Button type='primary' htmlType='submit' loading={modalLoading}>
              บันทึก
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
}

export default ProductCategory;
